import "./style.scss";

import ModalBase from "components/shared/ModalBase";
import StyledButton from "components/shared/StyledButton";
import { Body } from "helpers/TypographyComponents";
import { useTranslation } from "react-i18next";

interface SageUploadConfirmModalProps {
    /**
     * Whether the modal is open
     */
    open: boolean;
    /**
     * Triggers closing of modal
     */
    onClose: VoidFunction;
    /**
     * Triggers the upload to Sage.
     */
    onConfirm: () => Promise<void>;
    /**
     * Whether the upload is in progress.
     */
    isUploading: boolean;
}

/**
 * This modal confirms that the user wants to upload the accounting file to Sage.
 */
const SageUploadConfirmModal = ({ open, onClose, onConfirm, isUploading }: SageUploadConfirmModalProps) => {
    const [t] = useTranslation();

    return (
        <ModalBase open={open} onClose={onClose} modalTitle={t("PaymentModal.SageUploadConfirm.Title")}>
            <div className="sage-upload-confirm-modal-container">
                <Body>{t("PaymentModal.SageUploadConfirm.Message")}</Body>
                <div className="sage-upload-confirm-action-btns">
                    <StyledButton buttonType="secondary" onClick={onClose} disabled={isUploading} fullWidth>
                        {t("ModalBase.Cancel")}
                    </StyledButton>
                    <StyledButton buttonType="primary" onClick={onConfirm} loading={isUploading} fullWidth>
                        {t("ModalBase.Confirm")}
                    </StyledButton>
                </div>
            </div>
        </ModalBase>
    );
};

export default SageUploadConfirmModal;
